function cov_1ovl190zb6() {
  var path = "/app/src/constants/country-by-currency-map.ts";
  var hash = "f441dc024e3bbcda568ca2390a92a6f6e2e869a8";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/constants/country-by-currency-map.ts",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 70
        },
        end: {
          line: 10,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "f441dc024e3bbcda568ca2390a92a6f6e2e869a8"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1ovl190zb6 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1ovl190zb6();
export var COUNTRY_BY_CURRENCY_MAP = (cov_1ovl190zb6().s[0]++, {
  AED: 'UAE',
  SAR: 'KSA',
  KWD: 'KWT',
  BHD: 'BHR',
  QAR: 'QAT'
});